var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 0.75H2.75C1.64543 0.75 0.75 1.64543 0.75 2.75V16.75C0.75 17.8546 1.64543 18.75 2.75 18.75H16.75C17.8546 18.75 18.75 17.8546 18.75 16.75V2.75C18.75 1.64543 17.8546 0.75 16.75 0.75Z",
    stroke: "#DDC074",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 8.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75H18.75",
    stroke: "#DDC074",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.25 8.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 12.75V0.75",
    stroke: "#DDC074",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointLayout);
export default __webpack_public_path__ + "static/media/point-layout.b4321da1fad4951dcbea6a265de5e4ca.svg";
export { ForwardRef as ReactComponent };